import Http from './http'
import moment from 'moment'

class EmprestimoService {
  constructor() {
    this.baseUrl = '/emprestimos'
  }

  getAll(filter) {
    let url = `${this.baseUrl}`

    if (filter) {
      url += `?${this.buildFilterUrl(filter)}`
    }
    return Http.get(url)
  }

  getOne(id) {
    const url = `${this.baseUrl}/${id}`
    return Http.get(url)
  }

  edit(id, emprestimo) {
    const url = `${this.baseUrl}/${id}`
    return Http.put(url, emprestimo)
  }

  renovar(id) {
    return Http.put(`${this.baseUrl}/${id}/renovar`)
  }

  devolver(id) {
    return Http.put(`${this.baseUrl}/${id}/devolver`)
  }

  desdevolver(id) {
    return Http.put(`${this.baseUrl}/${id}/desdevolver`)
  }

  novo(emprestimo) {
    return Http.post(this.baseUrl, emprestimo)
  }

  getTopEmprestimos(children, filter) {
    let url = `${this.baseUrl}/top/emprestimos/semanas`
    url += `?children=${children}&${this.buildFilterUrl(filter)}`

    return Http.get(url)
  }

  getEmprestadosPorMes() {
    return Http.get(`${this.baseUrl}/pegos/por/mes`)
  }

  getTopMediaEmprestimosSemanas(children) {
    return Http.get(
      `${this.baseUrl}/top/emprestimos/media/semanas/1000?children=${children}`
    )
  }

  getTopLeitores(children) {
    return Http.get(`${this.baseUrl}/top/9?children=${children}`)
  }

  getTopAutores(children) {
    return Http.get(`${this.baseUrl}/top/authors/9?children=${children}`)
  }

  getTopCategorias(children) {
    return Http.get(`${this.baseUrl}/top/categorias/9?children=${children}`)
  }

  getTopBook(children) {
    return Http.get(`${this.baseUrl}/top/books/9?children=${children}`)
  }

  perdido(id, value) {
    const data = {
      perdido: value
    }
    return Http.put(`${this.baseUrl}/${id}/perdido`, data)
  }

  email(id) {
    return Http.post(`${this.baseUrl}/atrasado/email/${id}`, {})
  }

  marcarAssembleia(date) {
    const dateReq = {
      date: moment(date).format('YYYY-MM-DD')
    }
    return Http.patch(`${this.baseUrl}/assembleia`, dateReq)
  }

  buildFilterUrl(filter) {
    return Object.keys(filter)
      .map((key) => {
        if (key === 'orderBy') {
          return filter.orderBy.map(
            (order) => `orderBy[]=${order.orderBy},${order.direction || 'asc'}`
          )
        }
        if(filter[key] === null || filter[key] === '') {
          return ''
        }
        return `${key}=${filter[key]}`
      })
      .join('&')
  }
}

export default new EmprestimoService()
